import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './Main';
import Forbidden from './Forbidden';
import Login from './Login';
import Client from './components/Client';
import { APP_BASE_PATH } from './appBase';

window.client = new Client();

function App() {
  var data = JSON.parse(localStorage.getItem("apiUser"));

  
  if (data === null || data.accessToken === undefined || !window.client.isAccessTokenValid(data.accessToken)) {
    return <Login />
  }
  if (data.profile) {
    if (data.profile.user_status != 1)
      return <Login />
    if (parseInt(data.profile.user_type) < 29)
      return <Login />
  }
 
  // window.client.setConfigLocalStorage ( );
  // window.client.setLanguagesLocalStorage ( );

  return (
    
    <Router basename={APP_BASE_PATH || '/'}>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/main" element={<Main />} />
      </Routes>
    </Router>

  );
}

export default App;
